import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import PhoneSupport from "./PhoneSupport";
import EmailSupport from "./EmailSupport";
import RaisedTicket from "./RaiseTicket";
const AmtplSupport = () => {
    const [activeTab, setActiveTab] = useState("Raised Tickets");
     const tabs = ["Raised Tickets"];

    const renderTabContent = () => {
        switch (activeTab) {
            case "Email Support":
                return <EmailSupport />;
            case "Phone Support":
                return <PhoneSupport />;
            case "Raised Tickets":
                return <RaisedTicket />;
            default:
                return <RaisedTicket />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplSupport;